import { APIMessageType } from "./Types";
export function createAPI() {
    var nextLayerId = 1;
    var queuedMessages = [];
    var listeners = [];
    function emit(message) {
        if (listeners.length === 0) {
            queuedMessages.push(message);
        }
        else {
            listeners.forEach(function (listener) { return listener(message); });
        }
    }
    return {
        addListener: function (listener) {
            if (queuedMessages.length > 0) {
                queuedMessages.forEach(function (message) { return listener(message); });
                queuedMessages = [];
            }
            listeners.push(listener);
            return function () {
                var index = listeners.indexOf(listener);
                if (index !== -1) {
                    listeners.splice(index, 1);
                }
            };
        },
        pushLayer: function (render) {
            var key = "" + nextLayerId++;
            emit({
                type: APIMessageType.PushLayer,
                key: key,
                render: render
            });
            return key;
        },
        updateLayer: function (key, render) {
            emit({
                type: APIMessageType.UpdateLayer,
                key: key,
                render: render
            });
        },
        transitionExitLayer: function (key) {
            emit({
                type: APIMessageType.TransitionExitLayer,
                key: key
            });
        },
        removeLayer: function (key) {
            emit({
                type: APIMessageType.RemoveLayer,
                key: key
            });
        }
    };
}
export default createAPI();
